import { useSuspenseQuery } from '@tanstack/react-query';
import { createFileRoute } from '@tanstack/react-router';

import { DisciplineEdit } from '@/module/Discipline/DisciplineEdit';
import { getDisciplineOptions } from '@/module/Discipline/model/DisciplineQuery';

export const Route = createFileRoute(
  '/_auth/administration/_administration/discipline/_discipline/$disciplineId/_layout/edit',
)({
  component: RouteComponent,
  staticData: {
    pageTitle: { id: 'pageTitle.edit' },
  },
});

function RouteComponent() {
  const { disciplineId } = Route.useParams();
  const { data: discipline } = useSuspenseQuery(getDisciplineOptions(disciplineId));

  return <DisciplineEdit discipline={discipline} />;
}
